import React from "react";

const faqs = [
    {
        title: "Как быстро подключить платформу и начать использовать?",
        description: `<p>Подключение к HajjTravel занимает всего несколько шагов:</p>
<ol>
    <li>
        <p><strong>Оставьте заявку:</strong> Заполните форму на нашем сайте, и наш менеджер свяжется с вами для уточнения деталей.</p>
    </li>
    <li>
        <p><strong>Настройка аккаунта:</strong> Мы поможем вам настроить платформу в соответствии с вашими потребностями и предоставить доступ к тестовому периоду с полным функционалом.</p>
    </li>
    <li>
        <p><strong>Импорт данных:</strong> Загрузите данные о клиентах и турпакетах через Excel, Google Sheets или CSV за несколько секунд.</p>
    </li>
    <li>
        <p><strong>Обучение и поддержка:</strong> Мы предоставляем обучающие материалы и круглосуточную поддержку для быстрого освоения платформы.</p>
    </li>
</ol>
</br>
<p>После этих простых шагов вы сможете начать использовать все возможности HajjTravel и максимально эффективно управлять вашими турпакетами и клиентами.</p>`
    },
    {
        title: "Какие данные и интеграции нужны для начала работы?",
        description: `<p><strong>Какие данные и интеграции нужны для начала работы?</strong></p>
<p>Для начала работы с платформой HajjTravel вам понадобятся следующие данные и интеграции:</p>
<ol>
    <li>
        <p><strong>Данные о клиентах:</strong> Загрузите список ваших клиентов из Excel, Google Sheets или CSV. Мы поддерживаем быстрый импорт для удобства.</p>
    </li>
    <li>
        <p><strong>Информация о турпакетах:</strong> Загружайте данные о турпакетах (отели, рейсы, услуги) и настройте их в системе для дальнейшего использования.</p>
    </li>
    <li>
        <p><strong>Данные о платежах:</strong> Если вы планируете принимать платежи через платформу, предоставьте информацию о вашем платежном шлюзе (например, Kaspi, BCC, Halyk или другие интеграции).</p>
    </li>
    <li>
        <p><strong>Интеграции с внешними сервисами:</strong> Если вам нужно интегрировать платформу с вашими текущими системами (например, CRM, бухгалтерия или сервисы для связи с клиентами), мы поддерживаем API и можем помочь настроить эти интеграции.</p>
    </li>
    <li>
        <p><strong>Данные о документах туристов:</strong> Для автоматической проверки документов, таких как паспорта и визы, добавьте необходимые данные о ваших клиентах в систему.</p>
    </li>
</ol>
<p>Как только все данные будут загружены и интеграции настроены, вы сможете сразу начать использовать все возможности HajjTravel для управления вашими турами и клиентами.</p>`
    },
    {
        title: "Что такое HajjTravel и как он помогает турфирмам?",
        description: "HajjTravel — это платформа для автоматизации хадж- и умра-туров. Она помогает управлять клиентами, заказами, турпакетами, отслеживать поездки и предоставлять туристам удобные сервисы, такие как GPS-навигация, уведомления и SOS-кнопка."
    },
    {
        title: "Какой тарифный план мне выбрать?",
        description: "Выбор зависит от потребностей вашей турфирмы. Базовый подходит для небольших агентств, Премиум — для тех, кому важны уведомления и контроль поездок, а Бизнес предлагает максимальные возможности, включая инструменты для гидов и аналитику."
    },
    {
        title: "Как туристы могут использовать HajjTravel?",
        description: "Туристы могут получать уведомления, просматривать свой маршрут, использовать GPS-навигацию, связаться с гидом или службой поддержки через кнопку SOS.",
    },
    {
        title: "Какие инструменты есть для гидов?",
        description: "Гиды могут отслеживать местоположение туристов, просматривать их данные и оперативно реагировать в случае необходимости."
    },
    {
        title: " Можно ли принимать платежи через платформу?",
        description: "Да, тариф Бизнес позволяет принимать платежи за туры и управлять финансовыми потоками в удобном интерфейсе."
    },
    {
        title: "Как HajjTravel помогает контролировать поездки?",
        description: "Система позволяет отслеживать статус поездки, фиксировать изменения и уведомлять туристов о важных событиях."
    },
    {
        title: "Какие устройства поддерживаются?",
        description: "Платформа доступна на компьютерах, планшетах и мобильных устройствах."
    },
    {
        title: "Как можно подключиться к платформе?",
        description: "Оставьте заявку на сайте, и наш менеджер свяжется с вами для подключения и настройки системы."
    },
]

export default function AskedQuestions() {
    return (
        <div id="support" className="mt-20">
            <h2 className="my-3 text-3xl font-extrabold tracking-tight text-gray-900 text-center">Часто задаваемые вопросы</h2>
            <div className="p-4 mx-auto mt-20 space-y-2 shadow lg:w-1/2">
                {faqs.map((f, index) => {
                    return <div className="rounded-lg">
                        <summary className="font-semibold">{index + 1}. {f.title}</summary>
                        <div className="mt-3">
                            <p className="text-sm leading-6 text-gray-600" dangerouslySetInnerHTML={{ __html: f.description }} />
                        </div>
                    </div>
                })}
            </div>
        </div>
    );
}